import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { useDynamicGridTranslate } from "@ryde/redux";
import {
  FIELD_TYPE_IDS,
  gridControlsSF,
  IGenericUploadEntityCreateFieldItem,
} from "@ryde/shared";

const BOOKING_ENTITY = "booking";
const STATION_ENTITY = "station";

// Builds the "create fields if not found" toggles for the bulk bookings upload, scoped to the
// booking station (from/to) columns. Mirrors useGenericUploadEntityCreateFields, limited to stations.
export const useBulkUploadStationCreateFields =
  (): IGenericUploadEntityCreateFieldItem[] => {
    const { getGridLabelComputed } = useDynamicGridTranslate();
    const gridControls = useRecoilValue(gridControlsSF(BOOKING_ENTITY));

    return useMemo(() => {
      const options: IGenericUploadEntityCreateFieldItem[] = [];

      for (const gridControl of gridControls) {
        if (!gridControl.id) {
          continue;
        }

        if (
          gridControl.formFieldTypeId !== FIELD_TYPE_IDS.FORM.dropdown_bound
        ) {
          continue;
        }

        if (gridControl.formAttributes?.dropItemsSource !== STATION_ENTITY) {
          continue;
        }

        options.push({
          entity: STATION_ENTITY,
          customFieldId: gridControl.id,
          label: getGridLabelComputed(BOOKING_ENTITY, gridControl),
          isAllow: !!gridControl.formAttributes?.allowCreateIfNotFound,
        });
      }

      return options;
    }, [gridControls, getGridLabelComputed]);
  };
